import { Action } from '@ngrx/store';
import { Credentials } from '../../../shared/models/credentials';

export enum LoginActionTypes {
    DO_LOGIN_USER = '[Login] Login User',
    DO_LOGIN_USER_SUCCESS = '[Login] Login User Success',
    DO_LOGIN_USER_FAIL = '[Login] Login User Fail',
    DO_LOGIN_ANONYMOUS = '[Login] Login Anonymous',
    DO_LOGIN_ANONYMOUS_SUCCESS = '[Login] Login Anonymous Success',
    DO_LOGIN_ANONYMOUS_FAIL = '[Login] Login Anonymous Fail',
    DO_LOGIN_USER_RESET = '[Login] Login User Reset',
    DO_AUTOLOGIN_USER = '[Login] Autologin User',
    DO_AUTOLOGIN_USER_SUCCESS = '[Login] Autologin User Success',
    DO_AUTOLOGIN_USER_FAIL = '[Login] Autologin User Fail',
    DO_LOGIN_RESET_ERROR = '[Login] Reset Error',
    DO_LOGOUT = '[Login] Logout',
}

// LOGIN
export class DoLoginUser implements Action {
    readonly type = LoginActionTypes.DO_LOGIN_USER;
    constructor(public payload: Credentials) {}
}

export class DoLoginUserSuccess implements Action {
    readonly type = LoginActionTypes.DO_LOGIN_USER_SUCCESS;
    constructor(public payload: any) {}
}

export class DoLoginUserFail implements Action {
    readonly type = LoginActionTypes.DO_LOGIN_USER_FAIL;
    constructor(public payload: any) {}
}

// LOGIN ANONYMOUS
export class DoLoginAnonymous implements Action {
    readonly type = LoginActionTypes.DO_LOGIN_ANONYMOUS;
    constructor(public payload: Credentials) {}
}

export class DoLoginAnonymousSuccess implements Action {
    readonly type = LoginActionTypes.DO_LOGIN_ANONYMOUS_SUCCESS;
    constructor(public payload: any) {}
}

export class DoLoginAnonymousFail implements Action {
    readonly type = LoginActionTypes.DO_LOGIN_ANONYMOUS_FAIL;
    constructor(public payload: any) {}
}

export class DoLoginUserReset implements Action {
    readonly type = LoginActionTypes.DO_LOGIN_USER_RESET;
    constructor() {}
}

// AUTOLOGIN
export class DoAutologinUser implements Action {
    readonly type = LoginActionTypes.DO_AUTOLOGIN_USER;
    constructor(public payload: string) {}
}

export class DoAutologinUserSuccess implements Action {
    readonly type = LoginActionTypes.DO_AUTOLOGIN_USER_SUCCESS;
    constructor(public payload: any) {}
}

export class DoAutologinUserFail implements Action {
    readonly type = LoginActionTypes.DO_AUTOLOGIN_USER_FAIL;
    constructor(public payload: any) {}
}

// RESET ERROR
export class DoLoginResetError implements Action {
    readonly type = LoginActionTypes.DO_LOGIN_RESET_ERROR;
    constructor() {}
}

export class DoLogout implements Action {
    readonly type = LoginActionTypes.DO_LOGOUT;

    constructor() {}
}

export type LoginActions =
    | DoLoginUser
    | DoLoginUserSuccess
    | DoLoginUserFail
    | DoLoginAnonymous
    | DoLoginAnonymousSuccess
    | DoLoginAnonymousFail
    | DoLoginUserReset
    | DoAutologinUser
    | DoAutologinUserSuccess
    | DoAutologinUserFail
    | DoLoginResetError
    | DoLogout;
